import { FC, useState } from "react";
import Checkbox, { CheckboxProps } from "antd/lib/checkbox/Checkbox";
import Input from "antd/lib/input/Input";
import { Button, Form } from "antd";
import { fioValid, noLeadingSpaces, noTrailingSpaces } from "../../../utils";
import { IRegistrationFormValues } from "../../../types/types";
import styles from "./styles.module.css";
import { useAppDispatch, useAppSelector } from "../../../store";
import { SetPassport } from "../../../store/slices/registrationSlice";
import { tabsNamesKeys } from "../Registration.models";
import { ArrowLeftOutlined } from "@ant-design/icons";

const BASE_RULES = [
  {
    message: "Вы можете использовать только кириллицу",
    pattern: fioValid,
  },
  { message: "Уберите лишние пробелы", pattern: noTrailingSpaces },
  { message: "Уберите лишние пробелы", pattern: noLeadingSpaces },
];

enum FIELD_NAMES {
  name = "name",
  surname = "sur_name",
  patronymic = "patronymic",
}

interface IPassportProps {
  setStep: (step: tabsNamesKeys) => void;
}

const Passport: FC<IPassportProps> = ({ setStep }) => {
  const { passport } = useAppSelector(
    ({ registrationSlice }) => registrationSlice
  );
  const dispatch = useAppDispatch();

  const [form] = Form.useForm<IRegistrationFormValues>();

  const [isSubmittable, setIsSubmittable] = useState(false);
  const [disablePatronymic, setDisablePatronymic] = useState(false);

  const onChangeNoPatronymicHandler: CheckboxProps["onChange"] = ({
    target: { checked },
  }) => {
    setDisablePatronymic(checked);
    form.resetFields([FIELD_NAMES.patronymic]);
    form.setFieldsValue({ [FIELD_NAMES.patronymic]: "" });

    if (!checked) {
      form.validateFields([FIELD_NAMES.patronymic]);
    }
  };

  const onValuesChange = (_: any, allValues: any) => {
    const { name, sur_name, patronymic, noPatronymic } = allValues;
    const isValid =
      Boolean(name?.length) &&
      Boolean(sur_name?.length) &&
      (noPatronymic ? true : Boolean(patronymic?.length));

    setIsSubmittable(isValid);
  };

  const onFinishHandler = (values: IRegistrationFormValues) => {
    const { name, sur_name, patronymic } = values;
    const userData = {
      name,
      sur_name,
      patronymic,
    };

    dispatch(SetPassport(userData));
    setStep(tabsNamesKeys.phone);
  };

  return (
    <div className={styles.passport}>
      <p className={styles.subtitle}>Введите ваши личные данные</p>
      <Form
        form={form}
        layout="vertical"
        initialValues={passport}
        onValuesChange={onValuesChange}
        onFinish={onFinishHandler}
      >
        <div>
          <Form.Item
            name={FIELD_NAMES.surname}
            rules={[
              { required: true, message: "Введите фамилию" },
              ...BASE_RULES,
            ]}
          >
            <Input
              className={styles.input}
              maxLength={40}
              name={FIELD_NAMES.surname}
              type="text"
              placeholder="Фамилия"
            />
          </Form.Item>
          <Form.Item
            name={FIELD_NAMES.name}
            rules={[{ required: true, message: "Введите имя" }, ...BASE_RULES]}
          >
            <Input
              className={styles.input}
              maxLength={40}
              name={FIELD_NAMES.name}
              type="text"
              placeholder="Имя"
            />
          </Form.Item>
          <Form.Item
            name={FIELD_NAMES.patronymic}
            rules={[
              {
                required: !disablePatronymic,
                message: "Введите отчество",
              },
              ...BASE_RULES,
            ]}
          >
            <Input
              className={styles.input}
              name={FIELD_NAMES.patronymic}
              maxLength={40}
              disabled={disablePatronymic}
              type="text"
              placeholder="Отчество"
            />
          </Form.Item>
          <Form.Item
            name="noPatronymic"
            valuePropName="checked"
            className={styles.checkbox}
            required={false}
          >
            <Checkbox onChange={onChangeNoPatronymicHandler}>
              У меня нет отчества
            </Checkbox>
          </Form.Item>
        </div>
        <Form.Item shouldUpdate>
          <Button
            type="primary"
            className={styles.nextButton}
            disabled={!isSubmittable}
            htmlType="submit"
          >
            Продолжить
          </Button>
        </Form.Item>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          className={styles.backButton}
          onClick={setStep.bind(null, tabsNamesKeys.exit)}
        >
          Вернуться к авторизации
        </Button>
      </Form>
    </div>
  );
};

export default Passport;
